// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"35":"e3372ace","58":"8cb24a4a","156":"04531aaa","194":"d76aef49","372":"a9aef368","480":"7aeb1784","493":"37e79e83","602":"2740e537","818":"1848904f"}[chunkId] + ".chunk.js";
};